import React from 'react';

import DefaultPost from "./forms/DefaultPost";
import Covid19Post from "./forms/google/Covid19Post";
import OfferPost from "./forms/google/OfferPost";
import {GOOGLE, POST_TYPE} from "../../socialConstants";
import WhatsNewPost from "./forms/google/WhatsNewPost";

/**
 * To get a list of the valid types of posts, i.e. what will populate the tab structure, if any.
 */
export function getPostTypeTabs(provider) {
  if (provider === GOOGLE) {
    return [
      { key: 'QA', title: "Q & A", postTopicType: POST_TYPE.QA },
      { key: 'Alert', title: "COVID-19 Update", postTopicType: POST_TYPE.ALERT },
      { key: 'Offer', title: "Offers", postTopicType: POST_TYPE.OFFER },
      { key: 'WhatsNew', title: "What's New", postTopicType: POST_TYPE.WHATS_NEW }
    ]
  } else return []
}

/**
 * Give a postTopicType, get the form that it should represent.
 *
 * @param tab - [{key: String, title: String: postTopicType ?: String, default ?: Boolean}]
 * @param formProps
 */
export function getTabComponent(tab, formProps) {
  if (!tab) return <DefaultPost {...formProps} />;

  const { postTopicType } = tab;
  switch (postTopicType) {
    case POST_TYPE.ALERT:
      return <Covid19Post {...formProps} />;
    case POST_TYPE.OFFER:
      return <OfferPost {...formProps} />;
    case POST_TYPE.WHATS_NEW:
      return <WhatsNewPost {...formProps} />;
    case POST_TYPE.QA:
    default:
      return <DefaultPost {...formProps} />;
  }
}
